import { createContext } from "react";
const CategoryAttributeMapContext = createContext({});

export default CategoryAttributeMapContext;
